import { useUser } from "@ls/user-module";
import { useEffect } from "react";
import {
  requestScenarioOptions,
  requestUserInvestPlatform
} from "state/scenario/actions";
import { useDispatch, useSelector } from "react-redux";
import { selectInvestPlatform } from "state/scenario/selector";
import { setUserInvestPlatformIds } from "state/selections/actions";

export const useUserPlatformEffect = () => {
  const user = useUser();
  const username = user?.username;
  const dispatch = useDispatch();
  useEffect(() => {
    if (username) {
      dispatch(requestUserInvestPlatform(username));
    }
  }, [username, dispatch]);
};

export const useUserScenarioOptionsEffect = () => {
  const userInvestPlatform = useSelector(selectInvestPlatform);
  const dispatch = useDispatch();
  useEffect(() => {
    if (Object.keys(userInvestPlatform).length > 0) {
      var userInvestPlatformIds = null
      for (let key in userInvestPlatform) {
        if (!userInvestPlatformIds) {
          userInvestPlatformIds = userInvestPlatform[key].id?.investPlatformId;
        } else {
          userInvestPlatformIds = userInvestPlatformIds + "," + userInvestPlatform[key].id?.investPlatformId;
        }
        dispatch(setUserInvestPlatformIds(userInvestPlatformIds));
      }

      dispatch(requestScenarioOptions(userInvestPlatformIds));
    }
  }, [userInvestPlatform, dispatch]);
};


